"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var moment = require("moment");
var react_select_1 = require("react-select");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var list_1 = require("@caddigital/sok-reducers/lib/epics/activity/list");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var list_2 = require("@caddigital/sok-reducers/lib/reducers/activity/list");
var translate_1 = require("utils/translate");
var List_1 = require("./List");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
require("./style.scss");
var BidDetails_1 = require("./BidDetails");
var BidSelector_1 = require("./BidSelector");
var DatePicker_1 = require("components/DatePicker");
var utils_1 = require("./utils");
var components_1 = require("./components");
var PAGINATION_OPTIONS = [350, 700, 1400];
var Activity = function (props) {
    var _a = React.useState(null), authorSearch = _a[0], setAuthorSearch = _a[1];
    var _b = React.useState([]), typeSearch = _b[0], setTypeSearch = _b[1];
    var _c = React.useState(null), fromSearch = _c[0], setFromSearch = _c[1];
    var _d = React.useState(null), toSearch = _d[0], setToSearch = _d[1];
    var _e = React.useState('timestamp'), orderBy = _e[0], setOrderBy = _e[1];
    var _f = React.useState('desc'), order = _f[0], setOrder = _f[1];
    var _g = React.useState(350), limit = _g[0], setLimit = _g[1];
    var _h = React.useState(0), offset = _h[0], setOffset = _h[1];
    var _j = React.useState(null), selectedProject = _j[0], setSelectedProject = _j[1];
    var _k = React.useState(null), selectedBid = _k[0], setSelectedBid = _k[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var dispatchProps = React.useMemo(function () { return (0, utils_1.mapDispatchToProps)(dispatch); }, [dispatch]);
    var states = (0, react_redux_1.useSelector)(function (state) { return ({
        list: state.activity.list,
        projects: state.activity.projects,
        type: state.router.location.pathname.includes('/briefcase/')
            ? 'sokobid'
            : 'system',
        briefcase: state.briefcase.current.briefcase,
        bids: state.bid.list
    }); });
    var combinedProps = React.useMemo(function () {
        return __assign(__assign(__assign(__assign({}, props), dispatchProps), states), { authorSearch: authorSearch, setAuthorSearch: setAuthorSearch, typeSearch: typeSearch, setTypeSearch: setTypeSearch, fromSearch: fromSearch, setFromSearch: setFromSearch, toSearch: toSearch, setToSearch: setToSearch, orderBy: orderBy, setOrderBy: setOrderBy, order: order, setOrder: setOrder, limit: limit, setLimit: setLimit, offset: offset, setOffset: setOffset, selectedProject: selectedProject, setSelectedProject: setSelectedProject, selectedBid: selectedBid, setSelectedBid: setSelectedBid, language: (0, translate_1.getLanguage)() });
    }, [
        states,
        dispatchProps,
        authorSearch,
        typeSearch,
        fromSearch,
        toSearch,
        orderBy,
        order,
        limit,
        offset,
        selectedProject,
        selectedBid
    ]);
    var ops = __assign(__assign({}, list_2.initialSearchByOption), { from: fromSearch && fromSearch.unix() * 1000, to: toSearch && toSearch.unix() * 1000, user: authorSearch, project: selectedProject ? selectedProject.uuid : undefined, activity: typeSearch.length > 0 ? typeSearch.map(function (t) { return t.value; }) : null, order: order, orderBy: orderBy, offset: 0, limit: limit, type: states.type, briefcaseUuid: states.briefcase ? states.briefcase.uuid : null, bidUuid: selectedBid ? selectedBid.uuid : null });
    var getSearchOptions = function (overrides) {
        var _a;
        if (overrides === void 0) { overrides = {}; }
        return (__assign(__assign(__assign({}, list_2.initialSearchByOption), { from: fromSearch ? fromSearch.unix() * 1000 : undefined, to: toSearch ? toSearch.unix() * 1000 : undefined, user: authorSearch, project: selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.uuid, activity: typeSearch.length ? typeSearch.map(function (t) { return t.value; }) : null, briefcaseUuid: ((_a = states.briefcase) === null || _a === void 0 ? void 0 : _a.uuid) || null, bidUuid: (selectedBid === null || selectedBid === void 0 ? void 0 : selectedBid.uuid) || null, orderBy: orderBy, order: order, limit: limit, offset: offset }), overrides));
    };
    var onOrder = React.useCallback(function (orderBy, order) {
        setOrderBy(orderBy);
        setOrder(order || 'asc');
        dispatchProps.fetch(getSearchOptions({ orderBy: orderBy, order: order }));
    }, [setOrderBy, setOrder, dispatchProps.fetch, orderBy, order]);
    var onSetLimit = React.useCallback(function (limit, offset) {
        setOffset(offset);
        setLimit(limit);
        dispatchProps.fetch(getSearchOptions({ limit: limit, offset: offset }));
    }, [setOffset, setLimit, dispatchProps.fetch]);
    React.useEffect(function () {
        dispatchProps.fetchTypes(states.briefcase || undefined);
        if (states.briefcase) {
            combinedProps.fetchBids(states.briefcase);
        }
    }, [states.briefcase]);
    React.useEffect(function () {
        return function () {
            dispatchProps.clear();
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'activity-view' },
            React.createElement("main", { className: 'content' },
                combinedProps.type === 'sokobid' && combinedProps.briefcase ? (React.createElement(components_1.SokoBidBreadCrumb, { briefcase: combinedProps.briefcase, language: combinedProps.language })) : (React.createElement(components_1.SystemBreadCrumb, null)),
                React.createElement("div", { className: 'search-fields' },
                    React.createElement(sok_ui_1.Row, null,
                        React.createElement(sok_ui_1.Column, { medium: 6 },
                            React.createElement("label", { htmlFor: 'email' },
                                React.createElement(sok_ui_1.Icon, { className: 'fa-envelope' }),
                                ' ',
                                (0, translation_1.getLocalization)('userFront/admin/activity/limitToUser')),
                            React.createElement(sok_ui_1.TextInput, { type: 'text', id: 'email', name: 'email', value: combinedProps.authorSearch || '', onChange: function (e) {
                                    combinedProps.setAuthorSearch(e.target.value);
                                }, className: 'white' })),
                        React.createElement(sok_ui_1.Column, { medium: 6 },
                            React.createElement("label", { htmlFor: 'activity' },
                                React.createElement(sok_ui_1.Icon, { className: 'fa-briefcase' }),
                                ' ',
                                (0, translation_1.getLocalization)('userFront/admin/activity/limitToActivity')),
                            React.createElement(react_select_1.default, { menuPlacement: 'auto', classNamePrefix: 'react-select', className: 'activity-type-selector', id: 'activity', value: combinedProps.typeSearch, options: combinedProps.list.types.map(function (l) { return ({
                                    label: (0, translation_1.getLocalization)(l.name),
                                    value: l.id
                                }); }), isSearchable: false, isMulti: true, getOptionValue: function (opt) { return opt.value; }, getOptionLabel: function (opt) { return opt.label; }, onChange: function (e) {
                                    combinedProps.setTypeSearch(e);
                                } }))),
                    React.createElement(sok_ui_1.Row, null,
                        React.createElement(sok_ui_1.Column, { medium: 3, extraSmall: 6 },
                            React.createElement("label", { htmlFor: 'date' },
                                React.createElement(sok_ui_1.Icon, { className: 'fa-calendar' }),
                                ' ',
                                (0, translation_1.getLocalization)('userFront/admin/activity/limitToTime')),
                            React.createElement(DatePicker_1.DatePicker, { placeholder: (0, translation_1.getLocalization)('userFront/admin/activity/dateFrom'), selected: combinedProps.fromSearch &&
                                    moment(combinedProps.fromSearch, 'L HH:mm'), onChange: function (e) {
                                    combinedProps.setFromSearch(e);
                                }, timeIntervals: 15, timeFormat: "HH:mm", dateFormat: "L HH:mm", className: 'date', showTimeSelect: true, timeCaption: (0, translation_1.getLocalization)('datePicker/time') })),
                        React.createElement(sok_ui_1.Column, { medium: 3, extraSmall: 6 },
                            React.createElement(DatePicker_1.DatePicker, { placeholder: (0, translation_1.getLocalization)('userFront/admin/activity/dateTo'), selected: combinedProps.toSearch &&
                                    moment(combinedProps.toSearch, 'L HH:mm'), onChange: function (e) {
                                    combinedProps.setToSearch(e);
                                }, timeIntervals: 15, timeFormat: "HH:mm", dateFormat: "L HH:mm", showTimeSelect: true, timeCaption: (0, translation_1.getLocalization)('datePicker/time') })),
                        React.createElement(sok_ui_1.Column, { medium: 6, extraSmall: 12 },
                            React.createElement("label", { htmlFor: 'date' },
                                React.createElement(sok_ui_1.Icon, { className: 'fa-calendar' }),
                                ' ',
                                (0, translation_1.getLocalization)(combinedProps.type === 'sokobid'
                                    ? 'userFront/admin/activity/bid'
                                    : 'userFront/admin/activity/project')),
                            combinedProps.type === 'sokobid' ? (React.createElement(BidSelector_1.default, { bids: combinedProps.bids.list, onSelect: combinedProps.setSelectedBid, value: combinedProps.selectedBid })) : (React.createElement(components_1.ProjectSelector, { projects: combinedProps.projects.list, onChange: combinedProps.searchProject, onSelect: combinedProps.setSelectedProject, value: combinedProps.selectedProject, status: combinedProps.projects.status })))),
                    React.createElement("div", { className: 'button-list' },
                        React.createElement(sok_ui_1.Button, { color: 'blue', text: (0, translation_1.getLocalization)('userFront/admin/activity/search'), onClick: function () {
                                combinedProps.setOffset(0);
                                combinedProps.fetch(ops);
                            } }),
                        React.createElement(sok_ui_1.Button, { color: 'blue', text: (0, translation_1.getLocalization)('userFront/admin/activity/clear'), onClick: function () {
                                combinedProps.setAuthorSearch('');
                                combinedProps.setToSearch(null);
                                combinedProps.setFromSearch(null);
                                combinedProps.setTypeSearch([]);
                                combinedProps.setSelectedProject(null);
                                combinedProps.setSelectedBid(null);
                                combinedProps.setOffset(0);
                                var opts = {
                                    limit: combinedProps.limit,
                                    offset: 0,
                                    briefcaseUuid: combinedProps.briefcase
                                        ? combinedProps.briefcase.uuid
                                        : null,
                                    bidUuid: combinedProps.selectedBid
                                        ? combinedProps.selectedBid.uuid
                                        : null,
                                    type: combinedProps.type
                                };
                                combinedProps.fetch(opts);
                            } }),
                        combinedProps.type === 'system' && (React.createElement("a", { className: classNames('sok-button', 'sok-button-color-blue', 'export-activities'), href: "".concat(__APIBASEURL__, "api/admin/activity").concat((0, list_1.genQueryParams)(__assign(__assign({}, ops), { limit: undefined, offset: undefined, format: 'csv' }))) }, (0, translation_1.getLocalization)('global/export'))))),
                combinedProps.list.status === 'FETCHING' && (React.createElement("div", { className: 'container' },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                combinedProps.list.status === 'FAILED' && (React.createElement("div", { className: 'container' },
                    React.createElement(GenericErrorMessage_1.default, null,
                        React.createElement("p", null, (0, translation_1.getLocalization)('admin/userfront/admin/fetchFailed'))))),
                combinedProps.list.status === 'FETCHED' && [
                    React.createElement(List_1.ActivityList, { key: 'list', orderBy: combinedProps.orderBy, order: combinedProps.order, setOrder: onOrder, activities: combinedProps.list.activities, type: combinedProps.type, openActivityDetails: combinedProps.openActivityDetails }),
                    React.createElement(sok_ui_1.Pagination, { key: 'pagination', total: combinedProps.list.total, limit: combinedProps.limit, offset: combinedProps.offset, updatePageState: function (offset, limit) {
                            if (limit !== combinedProps.limit) {
                                onSetLimit(limit, 0);
                            }
                            onSetLimit(limit, offset);
                        }, limitOptions: PAGINATION_OPTIONS })
                ]),
            React.createElement(BidDetails_1.ActivityDetailsModal, null))));
};
exports.default = Activity;
